/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useContext} from 'react';
import {ColumnProps} from 'components/StickyHeadTable/StickyHeadTable';
import {useTranslation} from 'react-i18next';
import {LeaveRequest} from 'models/leaveRequest';
import {GET_LEAVE_HISTORY} from 'graphql/absences/Querys';
import {authContext} from 'contextApi/context/auth';
import GqlTableController from 'controllers/GqlTableController/GqlTableController';
import Status from 'components/Status/Status';
import {Button, Typography} from '@mui/material';
import {useNavigate, Link} from 'react-router-dom';
import {LeavesRoutes, PrivateRoutes} from 'navigation/routes';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {formatDateByLocale} from 'commons/formatDate';
import {SortLeaveRequestField} from 'models/SortLeaveRequestField';
import {SortOrder} from 'models/SortOrder';
import {useTranslateCatalog} from 'commons/hooks/useTranslateCatalog';

const LeaveRequestsTable: React.FC = () => {
  const {t, i18n} = useTranslation();
  const {translateCatalog} = useTranslateCatalog();
  const {userDetails} = useContext(authContext);
  const navigate = useNavigate();
  const columns: ColumnProps[] = [
    {
      id: 'dates_of_leave',
      label: t('leaves.LeaveRequestsTable.dates_of_leave'),
      render: (_: string, row) =>
        `${formatDateByLocale(
          row.startDate,
          i18n.language as 'en' | 'es' | 'fr' | 'pt'
        )} - ${formatDateByLocale(
          row.endDate,
          i18n.language as 'en' | 'es' | 'fr' | 'pt'
        )}`,
    },
    {
      id: 'request_date',
      label: t('leaves.LeaveRequestsTable.request_date'),
      render: (value: string) =>
        formatDateByLocale(value, i18n.language as 'en' | 'es' | 'fr' | 'pt'),
    },
    {
      id: 'type_of_absence',
      label: t('leaves.LeaveRequestsTable.type_of_absence'),
    },
    {
      id: 'days_of_leave',
      label: t('leaves.LeaveRequestsTable.days_of_leave'),
    },
    {
      id: 'status',
      label: t('leaves.LeaveRequestsTable.status'),
      render: (value: any) => <Status label={value} />,
    },
  ];

  const mapData = (data: LeaveRequest) => {
    return {
      ...data,
      dates_of_leave: `${data.startDate} - ${data.endDate}`,
      request_date: data.createdAt,
      type_of_absence:
        translateCatalog(data.typeOfLeave)?.description ||
        data.typeOfLeave?.description,
      days_of_leave: data.daysOff,
    };
  };
  return (
    <>
      <Typography variant="h5">
        {t('leaves.LeaveRequestsTable.title')}
      </Typography>
      <GqlTableController
        columns={columns}
        placeholder={t('common.empty_list')}
        hidePagination
        pageSize={6}
        mapData={mapData}
        actions={
          <Link to="/private/leaves/list">
            <Button variant="text" endIcon={<ArrowForwardIcon />}>
              {t('leaves.LeaveRequestsTable.see_all')}
            </Button>
          </Link>
        }
        rowProps={{
          onClick: (values: any) =>
            navigate(
              `/${PrivateRoutes.PRIVATE}/leaves/${LeavesRoutes.REQUEST_DETAIL}/${values.id}`
            ),
        }}
        queryConfiguration={{
          query: GET_LEAVE_HISTORY,
          rootField: 'leaveHistory',
          queryVariables: (page, size) => ({
            userId: userDetails?.data?.id,
            sort: {
              field: SortLeaveRequestField.START_DATE,
              order: SortOrder.DESC,
            },
            pageParams: {
              page,
              size,
            },
          }),
        }}
      />
    </>
  );
};

export default LeaveRequestsTable;
